import FormattedMessage from 'I18n/components/FormattedMessage';
import { getFullUrlWithCurrentSubDomain } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const getUserPreferencesUrl = () => `${getFullUrlWithCurrentSubDomain()}/settings/${PortalIdParser.get()}/user-preferences/calling`;
export const ChangeProviderLink = ({
  onCallButtonClick,
  providerName
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    paddingBlockStart: "300",
    paddingInline: "400",
    paddingBlockEnd: "0",
    "data-selenium-test": "selected-help-desk-provider",
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "heading-200",
      children: providerName
    }), /*#__PURE__*/_jsx(Link, {
      external: true,
      href: getUserPreferencesUrl(),
      onClick: onCallButtonClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "callWorkspacePopover.changeCallingProvider"
      })
    })]
  });
};